



























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import gql from 'graphql-tag'

@Component({
  name: 'apologizeModal'
})
export default class extends Vue {
  @Prop() offerId!: string
  @Prop() amountValue!: number

  // joinWaitlist() {
  //   this.$apollo
  //     .mutate({
  //       mutation: gql`
  //         mutation($offerId: ID, $amount: Decimal) {
  //           addUserToOfferWaitlist(offerId: $offerId, amount: $amount) {
  //             offer {
  //               offerWaitlist {
  //                 amount
  //                 user {
  //                   id
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       `,
  //       variables: {
  //         offerId: this.offerId,
  //         amount: this.amountValue
  //       }
  //     })
  //     .then(() => {
  //       this.$bvModal.hide('modal-apologize')
  //     })
  // }
}
